'use strict';
import {ConfirmButtonDirective} from './ConfirmButtonDirective';
const angular = require('angular');

const StatefulButtonDirective = require('./StatefulButtonDirective.js');

module.exports = angular
  .module('app.components.transforming-buttons', [])
  .directive('confirmButton', ConfirmButtonDirective)
  .directive('statefulButton', StatefulButtonDirective.directive)
  .controller('StatefulButtonController', StatefulButtonDirective.controller);



// WEBPACK FOOTER //
// ./src/js/core-components/transforming-buttons/index.js